module.exports = {
    'Breakpoints': require('./breakpoints'),
    'TypeAhead': require('./type-ahead'),
    'ConsentGroupPatterns': require('./consent-group-patterns')
};